module.exports = __webpack_public_path__ + "img/login-bottom-icon.782e63e8.jpg";